import ProfileIcon from './Profile'
import DownArrowIcon from './DownArrow'

import SearchIcon from './Search'
import SearchArrowIcon from './SearchArrow'

export default {
    ProfileIcon,
    DownArrowIcon,
    SearchIcon,
    SearchArrowIcon
}
